import React, {
  useContext,
  useEffect,
  useState,
  useRef,
} from 'react';
import { SelectionTreeContext } from '../context';

import { buildMap, filterTreeItems } from '../utils';
import { DataSourceProps } from '../types';

export const HybridClientDataSource: React.FC<DataSourceProps> = ({ treeItems, customFilter, fetchData }) => {
  const [allItems, setAllItems] = useState(treeItems);
  const {
    searchQuery,
    itemsMap,
    updateItemsMap,
    updateItems,
    openItems,
  } = useContext(SelectionTreeContext);
  const previousOpenItems = useRef(openItems);

  useEffect(() => {
    if (fetchData && previousOpenItems.current.size < openItems.size) {
      const newOpenItem = [...openItems].filter((x) => !previousOpenItems.current.has(x));
      if (newOpenItem.length > 0) {
        const [itemKey] = newOpenItem;
        const item = allItems.find((x) => x.value === itemKey);
        if (item && item.lazyLoad) {
          if (item.isLoaded) {
            return;
          }
          item.isLoaded = true;
          item.isLoading = true;
          setAllItems([...allItems]);
          fetchData({ key: itemKey }).then((data) => {
            item.isLoading = false;
            const children = data.map((child) => ({
              ...child,
              parentValue: item.value,
            }));
            setAllItems((prevItems) => [...prevItems, ...children]);
          });
        }
      }
    }
    previousOpenItems.current = openItems;
  }, [openItems, allItems, fetchData]);

  useEffect(() => {
  }, [openItems]);

  useEffect(() => {
    const newItemsMap = buildMap(allItems);
    updateItemsMap(newItemsMap);
  }, [allItems]);

  useEffect(() => {
    const filteredTreeItems = filterTreeItems(allItems, itemsMap, searchQuery, customFilter);

    updateItems(filteredTreeItems);
  }, [allItems, itemsMap, searchQuery, customFilter, updateItems]);

  return null;
};
